import type {ReactElement} from 'react';
import {InputField} from '@Components/input-field-v2';
import type {InputType} from '@Components/input-field-v2/input-field.types';
import {InputFieldType} from '@Components/input-field-v2/input-field.types';
import {Text, TextSize} from '@Components/text';
import {useEventWizardTicketingConfig} from '@Components/event-wizard/event-wizard.hooks';
import {onEventWizardTicketingSectionDescriptionChange, onEventWizardTicketingSectionTitleChange} from '@Components/event-wizard/event-wizard-slice';
import {getDefaultTicketingFormTitle, MAX_SECTION_DESCRIPTION_LENGTH, MAX_SECTION_TITLE_LENGTH} from '@Components/event-wizard/event-wizard-ticketing/event-wizard-ticketing.types';
import {TicketingWhoRespondsDropdown} from '@Components/event-wizard/event-wizard-ticketing/components/ticketing-who-responds-dropdown/ticketing-who-responds-dropdown';
import {TicketingQuestions} from '@Components/event-wizard/event-wizard-ticketing/components/ticketing-questions/ticketing-questions';
import {useAppDispatch} from '@/hooks';

export function TicketingCustomForm(): ReactElement {
  const dispatch = useAppDispatch();
  const config = useEventWizardTicketingConfig();

  const onTitleChange = (value: InputType): void => {
    dispatch(onEventWizardTicketingSectionTitleChange(value.toString()));
  };

  const onDescriptionChange = (value: InputType): void => {
    dispatch(onEventWizardTicketingSectionDescriptionChange(value.toString()));
  };

  return (
    <div className="gap-4 flex-column-align-start _full-width">
      <div className="flex-column-align-start">
        <Text className="spacing-m-b-1" val={window.i18next.t('pmwjs_event_ticketing_custom_form')} size={TextSize.LG} bold />
        <Text className="ct-neutral-secondary" val={window.i18next.t('pmwjs_event_ticketing_custom_form_sub')} size={TextSize.SM} />
      </div>

      <div className="flex-column-align-start _full-width">
        <TicketingWhoRespondsDropdown />
      </div>

      <div className="flex-column-align-start _full-width">
        <InputField
          className="_full-width"
          inputClassName="corner-radius-8"
          input={config.questionSectionTitle}
          onInputChange={onTitleChange}
          label={window.i18next.t('pmwjs_event_ticketing_form_title')}
          placeholder={getDefaultTicketingFormTitle(config)}
          inputType={InputFieldType.TEXT}
          maxLength={MAX_SECTION_TITLE_LENGTH}
          enforceMaxLength
        />
      </div>

      <div className="flex-column-align-start _full-width">
        <InputField
          className="_full-width"
          inputClassName="corner-radius-8"
          input={config.questionSectionDescription}
          onInputChange={onDescriptionChange}
          label={window.i18next.t('pmwjs_event_ticketing_form_description')}
          placeholder={window.i18next.t('pmwjs_event_ticketing_form_description_placeholder')}
          maxLength={MAX_SECTION_DESCRIPTION_LENGTH}
          enforceMaxLength
          isMultiline
          maxNumberOfRows={3}
        />
      </div>

      <div className="flex-column-align-start _full-width">
        <TicketingQuestions />
      </div>
    </div>
  );
}
